import state from '@/store/modules/auctions/defaultState';

const actions = {
  getMyAcvActiveBuyingAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    dispatch('getAuctionList', {
      subscribeAuctions: true,
      apiMethod: 'getMyAcvActiveBuyingAuctions',
      moduleKey: 'MyAcvActiveBuying',
      numberOfLoaders: 10,
      page,
    });
  },
};

export default {
  state,
  actions,
};
